module.exports = __webpack_public_path__ + "static/media/alessia.b44ad279.jpg";